import { useEffect, useState } from "react";
import Sheet from "react-modal-sheet";
import { selectCameraIntent, selectCameraBSTabIndex, updateOffCanvasViewPayload, selectAskResults, selectCameraHelp, selectCameraReady, offCanvasInitialState } from "@/store/slices/offCanvas";
import { useDispatch, useSelector } from "react-redux";
import Header from "./Header";
import ImageSearch from "./ImageSearch";
import TextSearch from "./TextSearch";
import VoiceSearch from "./VoiceSearch";
import AskResults from "./AskResults";
import CameraHelp from "./CameraHelp";

const CameraBSContent = () => {
  const selectedTabIndex = useSelector(selectCameraBSTabIndex);
  const ready = useSelector(selectCameraReady);

  return <div className={`p-0 w-full h-full bg-black flex-col ${ready ? "hidden" : "flex"}`}>
    {selectedTabIndex === 0 && <VoiceSearch />}
    {selectedTabIndex === 1 && <ImageSearch />}
    {selectedTabIndex === 2 && <TextSearch />}
  </div>
}

const CameraBS = () => {
  const dispatch = useDispatch();
  const isCameraBSOpen = useSelector(selectCameraIntent);
  const results = useSelector(selectAskResults);
  const help = useSelector(selectCameraHelp);

  const [isVertical, setIsVertical] = useState<boolean>(window.innerWidth > window.innerHeight ? false : true);

  const handleOrientation = (e: any) => {
    switch (e.currentTarget.type) {
      case "landscape-primary":
      case "landscape-secondary":
        setIsVertical(false);
        break;
      case "portrait-secondary":
      case "portrait-primary":
      default:
        setIsVertical(true);
    }
  }

  const openCameraBS = async () => {
    window.screen.orientation.addEventListener("change", handleOrientation);
  }

  const closeCameraBS = () => {
    window.screen.orientation.removeEventListener("change", handleOrientation);
  }

  const resetState = () => {
    dispatch(updateOffCanvasViewPayload({ CAMERA: { ...offCanvasInitialState.data.CAMERA } }));
  }

  useEffect(() => {
    if (!isCameraBSOpen) {
      closeCameraBS();
    }
    openCameraBS();
  }, [isCameraBSOpen]);

  return (
    <Sheet disableDrag isOpen={isCameraBSOpen} onClose={resetState} detent="full-height" mountPoint={document.getElementById("base-layout") as any}>
      <Sheet.Container className="!h-full">
        {
          !isVertical && <Sheet.Content className="p-0 w-full h-full bg-black flex flex-col justify-center items-center">
            <span className="text-white text-2xl text-center">Please rotate your device to portrait mode</span>
          </Sheet.Content>
        }
        <Sheet.Content className={`p-0 w-full h-full bg-black flex-col ${isVertical ? "flex" : "!hidden"}`}>
          <Header />
          <CameraBSContent />
          {!!results.length && <AskResults />}
          {help && <CameraHelp />}
        </Sheet.Content>
      </Sheet.Container>
    </Sheet >
  );
}

export default CameraBS;